import Vue from "vue";
import PizZip from "pizzip";
import JSZipUtils from "jszip-utils";
import Docxtemplater from "docxtemplater";
import ImageModule from "docxtemplater-image-module-free";

const base64DataURLToArrayBuffer = (dataURL) => {
  // 解析图片
  let base64Index = dataURL.indexOf(";base64,");
  if (base64Index < 0) {
    throw new Error("Invalid data URL.");
  }

  let base64Data = dataURL.substring(base64Index + 8);
  let binaryString = atob(base64Data);
  let len = binaryString.length;
  let bytes = new Uint8Array(len);

  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  return bytes.buffer;
};

export const exportdocx = (fileUrl, data) => {
  return new Promise((resolve) => {
    JSZipUtils.getBinaryContent(fileUrl, (error, content) => {
      if (error) {
        throw error;
      }

      let opts = { centered: false };
      opts.getImage = (chartId) => {
        return base64DataURLToArrayBuffer(chartId);
      };
      opts.getSize = (img, tagValue, tagName) => {
        return [200, 200];
      };

      let zip = new PizZip(content);
      let doc = new Docxtemplater();
      doc.attachModule(new ImageModule(opts));
      doc.loadZip(zip);
      doc.setOptions({ paragraphLoop: true, linebreaks: false });
      doc.compile();

      doc.renderAsync({ ...data }).then(() => {
        let out = doc.getZip().generate({
          type: "blob",
          mimeType:
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        });
        resolve({ out, data });
      });
    });
  });
};

Vue.prototype.$exportdocx = exportdocx;
